<template lang="pug">
  div
    slot(name="picker")
    input(
      ref="fileInputActivator"
      type="file"
      @change="fileChange"
    ).hide
    v-dialog(
      v-model="dialog"
      persistent
      :width="minContainerWidth"
      :fullscreen="fullscreen"
    )
      v-card
        v-toolbar(flat)
          h2 Crop Photo
          v-spacer
          v-btn(icon @click.stop="close")
            v-icon mdi-close
        v-card-text.pa-0
          v-row(
            justify="center"
            no-gutters
          )
            v-col(cols="12").text-center
              vue-cropperjs(
                ref="cropperRef"
                @crop="result"
                :height="350"
                :max-height="350"
                :aspect-ratio="aspectRatio"
                :view-mode="2"
              ).containerHeight
        v-divider
        v-card-actions
          v-spacer
          v-btn(text large color="primary" @click="rotate(-90)")
            v-icon mdi-rotate-left
            | Rotate Left
          v-btn(text large color="primary" @click="rotate(90)")
            v-icon mdi-rotate-right
            | Rotate Right
          v-btn(depressed large color="primary" @click.stop="crop")
            v-icon mdi-crop
            |  Crop
          v-btn(depressed large color="error" @click.stop="skipCrop" v-if="!forceCrop")
            v-icon mdi-close
            |  Skip Cropping
          v-spacer

</template>

<script>
import VueCropperjs from './VueCropperjs';

export default {
  components: {
    VueCropperjs
  },
  props: {
    forceCrop: Boolean,
    aspectRatio: {
      type: Number,
      default: null
    },
    fullscreen: Boolean
  },
  data () {
    return {
      dialog: false,
      confirmDialog: false,
      source: '',
      minContainerWidth: 800,
      minContainerHeight: 500
      // load: false
    };
  },
  updated () {
    if (this.source && this.$refs.cropperRef) { this.bind(); }
  },
  methods: {
    selectFile () {
      this.$refs.fileInputActivator.click();
    },
    fileChange (file) {
      if (!file.target.files[0].name.match(/.(jpg|jpeg|png|gif)$/i)) {
        window.alert('Invalid image file. Must be JPG, JPEG, PNG or GIF');
        file.target.value = null;
        return;
      }
      var reader = new window.FileReader();
      reader.readAsDataURL(file.target.files[0]);
      reader.onload = () => {
        this.$nextTick(() => {
          this.dialog = true;
          this.source = reader.result;
          file.target.value = null;
        });
      };
      reader.onerror = (error) => {
        console.log('Error: ', error);
      };
    },
    bind () {
      this.$refs.cropperRef.bind(this.source);
    },
    confirmCrop (doCrop) {
      if (doCrop) {
        this.dialog = true;
      } else {
        this.$emit('done', this.source);
      }
      this.confirmDialog = false;
    },
    rotate (direction) {
      this.$refs.cropperRef.rotate(direction);
    },
    crop () {
      this.$refs.cropperRef.crop();
      this.close();
    },
    skipCrop () {
      this.$emit('done', this.source);
      this.close();
    },
    result (res) {
      this.$emit('done', res);
    },
    close () {
      this.dialog = false;
      this.source = '';
      this.$refs.cropperRef.destroy();
    }
  }
};
</script>

<style scoped>
  .img-display:hover {
    cursor: pointer;
  }
  .hide {
    display: none;
  }
  .containerHeight {
    max-height: 500px !important;
  }
</style>
